import React, { useRef, useState } from 'react';
// Styles provided by RestaurantOnboarding.css

const TERMS_SECTIONS = [
  {
    title: '1. Identificación de la empresa',
    body: 'Jama es una plataforma tecnológica operada por Beez Cía. Ltda., compañía legalmente constituida bajo las leyes de la República del Ecuador.\n\nSitio web oficial: https://www.jamaec.com\nCorreo de soporte: soporte@jamaec.com\n\nJama es una plataforma digital que conecta locales comerciales (restaurantes, cafeterías, tiendas y otros establecimientos) con usuarios finales para la compra y entrega de productos.',
  },
  {
    title: '2. Objeto del servicio',
    body: 'La presente política regula la relación entre Jama y los locales afiliados que deseen ofrecer sus productos a través de la aplicación móvil y/o página web.\n\nJama actúa como:\n• Plataforma tecnológica intermediaria.\n• Facilitador de pagos digitales.\n• Canal de promoción y visibilidad comercial.\n• Sistema de gestión de pedidos.\n\nJama no es propietaria de los productos ofrecidos por el local, ni es responsable de su preparación, calidad o condiciones sanitarias.',
  },
  {
    title: '3. Registro del local',
    body: 'Para formar parte de la plataforma, el local deberá:\n• Proporcionar información veraz y actualizada.\n• Entregar RUC activo.\n• Proporcionar datos bancarios correctos.\n• Indicar dirección física exacta del establecimiento.\n• Listar productos con precios actualizados.\n• Cumplir la normativa sanitaria y comercial vigente en Ecuador.\n\nJama se reserva el derecho de aprobar o rechazar solicitudes de afiliación.',
  },
  {
    title: '4. Obligaciones del local',
    body: 'El local se compromete a:\n• Mantener actualizados precios y disponibilidad.\n• Garantizar la calidad y correcta preparación de los productos.\n• Cumplir tiempos de preparación razonables.\n• Empacar adecuadamente los pedidos.\n• Cumplir la normativa de higiene y permisos municipales.\n• No utilizar la plataforma para comercializar productos ilegales.\n\nEstá estrictamente prohibido vender drogas o sustancias ilícitas, armas, productos falsificados o cualquier artículo prohibido por la ley ecuatoriana.',
  },
  {
    title: '5. Comisiones y pagos',
    body: 'Jama cobrará una comisión por cada pedido completado, cuyo porcentaje será establecido en el contrato comercial individual con el local.\n\nLos pagos se realizarán mediante transferencia bancaria en los plazos acordados.\n\nJama podrá retener valores en caso de reclamos verificados, fraudes o cancelaciones indebidas atribuibles al local.',
  },
  {
    title: '6. Cancelaciones y reclamos',
    body: 'Si un pedido es cancelado por falta de stock, error en precios, incumplimiento de tiempos o negativa injustificada, Jama podrá aplicar penalizaciones internas.\n\nEl local es responsable directo ante el cliente por la calidad, presentación, cantidad y condiciones sanitarias de los productos.',
  },
  {
    title: '7. Uso de marca y contenido',
    body: 'El local autoriza a Jama a publicar su logo, utilizar imágenes de sus productos, realizar campañas promocionales e incluirlo en material publicitario digital.\n\nEl local declara tener derechos sobre las imágenes proporcionadas.',
  },
  {
    title: '8. Responsabilidad',
    body: 'Jama actúa exclusivamente como intermediario tecnológico. No es responsable por daños derivados del consumo, intoxicaciones alimentarias, incumplimientos sanitarios ni problemas internos del establecimiento.\n\nLa responsabilidad sobre los productos recae exclusivamente en el local.',
  },
  {
    title: '9. Terminación del servicio',
    body: 'Jama podrá suspender o cancelar la cuenta del local en caso de incumplimiento reiterado, mala reputación o múltiples reclamos, actividades ilegales o daño a la imagen de la plataforma.\n\nEl local podrá solicitar su retiro notificando por escrito.',
  },
  {
    title: '10. Protección de datos',
    body: 'El local se compromete a tratar los datos de clientes conforme a la normativa ecuatoriana de protección de datos. Está prohibido utilizar información de clientes para fines distintos a la gestión del pedido.',
  },
  {
    title: '11. Modificaciones',
    body: 'Jama podrá actualizar estos términos en cualquier momento. Las modificaciones serán notificadas por medios digitales.',
  },
  {
    title: '12. Jurisdicción',
    body: 'Estos términos se rigen por las leyes de la República del Ecuador. Cualquier disputa será resuelta ante los tribunales competentes del Ecuador.',
  },
];

const StepRestaurantTerms = ({ formData, onUpdate, errors = {}, onClearError }) => {
  const scrollRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
      setScrolled(true);
    }
  };

  const handleAccept = (e) => {
    onUpdate({ terms_accepted: e.target.checked });
    if (onClearError) onClearError('terms_accepted');
  };

  return (
    <div className="ro-body ro-basic">

      <div className="ro-step-hd">
        <span className="ro-eyebrow ro-eyebrow--accent">Paso 11 · Términos</span>
        <h2 className="ro-title">Términos y condiciones</h2>
        <p className="ro-subtitle">
          Lee detenidamente el acuerdo antes de completar tu registro.
        </p>
      </div>

      {/* Terms scroll box */}
      <div
        className="ro-terms-box"
        ref={scrollRef}
        onScroll={handleScroll}
      >
        <p className="ro-terms-meta">
          JAMA – Beez Cía. Ltda. · Última actualización: febrero 2026
        </p>

        {TERMS_SECTIONS.map((s) => (
          <div key={s.title} className="ro-terms-section">
            <h4 className="ro-terms-heading">{s.title}</h4>
            {s.body.split('\n').map((line, i) =>
              line.trim() === '' ? null : (
                <p key={i} className="ro-terms-p">{line}</p>
              )
            )}
          </div>
        ))}
      </div>

      {!scrolled && (
        <p className="ro-terms-hint">↓ Desplázate para leer el documento completo</p>
      )}

      {/* Checkbox */}
      <label className={`ro-terms-check-wrap${errors.terms_accepted ? ' ro-terms-check-wrap--err' : ''}`}>
        <input
          type="checkbox"
          className="ro-terms-check-input"
          checked={!!formData.terms_accepted}
          onChange={handleAccept}
        />
        <span className="ro-terms-check-box" aria-hidden>
          {formData.terms_accepted && (
            <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
              <polyline points="2,6 5,9 10,3" stroke="white" strokeWidth="2.2"
                strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </span>
        <span className="ro-terms-check-lbl">
          He leído y acepto los <strong>Términos y Condiciones</strong> para locales afiliados de JAMA.
        </span>
      </label>

      {errors.terms_accepted && (
        <span className="ro-err-msg ro-terms-err">{errors.terms_accepted}</span>
      )}

    </div>
  );
};

export default StepRestaurantTerms;
